/**
 * @file コンポーネント：症例サムネイル動画 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { RavnurPlayer } from "~/src/components/uiparts/RavnurPlayer";

// スタイル読み込み
import { StyledMedia } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledMedia>
            <RavnurPlayer
                fairplayCer={props.fairplayCer}
                fairplayLaUrl={props.fairplayLaUrl}
                hasAudio={false}
                hideControl={true}
                hidePlaceholder={true}
                id={props.promotionId}
                mediaId={"ad-" + props.promotionId}
                movieUrl={props.thumbnail}
                options={{
                    muted: true,
                }}
                playreadyLaUrl={props.playreadyLaUrl}
                setMediaPlayer={props.setMediaPlayerThumbnail}
                widevineLaUrl={props.widevineLaUrl}
                operationId={props.operationId}
            />
        </StyledMedia>
    );
};
